import RequestBase from '../Resources/RequestBase';

export class CreateCredentialsRequest extends RequestBase {
    constructor(success) {
        super();
        this._url = '/Credentials';
        this.method = 'POST';
        this.parameters = [
            'username',
            'password'
        ];
        this.anonymous = true;
        this.test = true;
        this.success = success;
        this.error = 'Wrong parameters';
        this.data = {};
    }
}

export class UpdateCredentialsRequest extends RequestBase {
    constructor(success) {
        super();
        this._url = '/Credentials';
        this.method = 'PATCH';
        this.contentType = 'application/json';
        this.anonymous = true;
        this.test = true;
        this.success = success;
        this.error = 'Wrong parameters';
        this.data = {};
    }
}



// WEBPACK FOOTER //
// ./src/TestResources/Credentials.js